// src/pages/Services.tsx (Updated - no CSS import)
import React from 'react';
import { Helmet } from 'react-helmet-async';

import SpecialPackages from '../components/SpecialPackages/SpecialPackages.tsx';
import HowItWorks from '../components/HowItWorks/HowItWorks.tsx';

const Services: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Vedic Astrology Services and Prices | Kundali, Jyotish and Vaastu | Astrologer Kavitha Nandy</title>
        <meta name="description" content="Explore Vedic astrology services by Astrologer Kavitha Nandy: Whole Life Reading ($60), Relationship Compatibility ($25), Career and Finance ($25), Birth Time Rectification ($60), Vaastu Shastra ($150). Remote consultations across the USA." />
        <link rel="canonical" href="https://cosmickavi.com/services" />
      </Helmet>
      <section className="page-header">
        <div className="container">
          <h1>Our Mystical Services</h1>
          <p>Choose from our comprehensive range of astrological services designed to illuminate your path</p>
        </div>
      </section>
      
      <SpecialPackages />
      <HowItWorks />
    </>
  );
};

export default Services;